import type { IconData } from '@stacksjs/iconify-core'

export const navigationArrowOffSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m3.6 21.587l13.364 7.327l4.165-4.164l-11.83-11.83c-2.419 1.146-4.482 2.249-6.01 3.224c-1.04.664-1.532 1.765-1.43 2.863c.099 1.068.744 2.034 1.741 2.58m19.65 5.284l-4.164 4.165L26.413 44.4c.546.997 1.512 1.642 2.58 1.741c1.098.102 2.2-.39 2.863-1.43c.975-1.528 2.079-3.591 3.224-6.01zm13.157 8.915L25.371 24.75l19.75-19.749c.15.457.203.957.137 1.477c-.812 6.399-3.062 14.22-5.634 21.262a140 140 0 0 1-3.217 8.046M23.25 22.629L12.214 11.593a140 140 0 0 1 8.046-3.217c7.042-2.572 14.864-4.822 21.262-5.634a3.4 3.4 0 0 1 1.477.138z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M5.232 1.232a2.5 2.5 0 0 1 3.536 0l38 38a2.5 2.5 0 0 1-3.536 3.536l-38-38a2.5 2.5 0 0 1 0-3.536\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default navigationArrowOffSolid
